<!-- NEW DESIGN FOR MISSING DOCUMENTS (FIGMA MATCH) -->
<div *ngIf="isMissing" 
     style="width: 212px; height: 200px; position: relative; background: #FFFBF2; overflow: hidden; border-radius: 12px; outline: 1px #E5C55C solid; outline-offset: -1px">
  
  <!-- Title -->
  <div style="left: 16px; top: 26px; position: absolute; justify-content: center; display: flex; flex-direction: column; color: #1A1A2E; font-size: 16px; font-weight: 500; line-height: 20px; word-wrap: break-word">
      {{ doc.title }}
  </div>

  <!-- Footer Section with Button -->
  <div style="width: 180px; height: 52px; left: 16px; top: 148px; position: absolute; border-top: 1px #E8E8F0 solid">
    <div style="width: 102.48px; height: 28px; left: 77px; top: 11px; position: absolute; background: #000086; border-radius: 7px; cursor: pointer;"
         (click)="editDocument()">
      <!-- Icon -->
      <div style="width: 11px; height: 11px; left: 10px; top: 8.50px; position: absolute; overflow: hidden">
          <i class="pi pi-upload" style="font-size: 10px; color: white; display: flex; align-items: center; justify-content: center; height: 100%;"></i>
      </div>
      <!-- Label -->
      <div style="width: 66.78px; height: 15px; left: 26px; top: 6.50px; position: absolute; text-align: center; justify-content: center; display: flex; flex-direction: column; color: white; font-size: 11.50px; font-weight: 600; word-wrap: break-word">
          Upload Now
      </div>
    </div>
  </div>

  <!-- Requested Info -->
  <div *ngIf="doc.isRequested" style="left: 16px; top: 88px; position: absolute; display: flex; flex-direction: column; gap: 4px; width: 213px;">
    <div style="color: #64748B; font-size: 10px; font-weight: 500;">
        Requested by: <span style="color: #1A1A2E; font-weight: 600;">{{ doc.requestedByUsername || 'GradPilots Staff' }}</span>
    </div>
    <div *ngIf="doc.remarks" style="color: #64748B; font-size: 10px; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;" [title]="doc.remarks">
        <i class="pi pi-info-circle" style="font-size: 8px; margin-right: 2px;"></i> {{ doc.remarks }}
    </div>
  </div>

  <!-- Status Badge (Normal Look) -->
  <div style="height: 19px; left: 16px; top: 65px; position: absolute; background: #FEF3C7; border-radius: 16px; display: flex; align-items: center; padding: 0 8px; border: 0.5px solid #FCD34D;">
    <i class="pi pi-exclamation-circle" style="color: #B45309; font-size: 10px;"></i>
    <span style="margin-left: 4px; color: #B45309; font-size: 10px; font-weight: 600; text-transform: uppercase;">
        Missing
    </span>
  </div>
</div>

<!-- OLD DESIGN FOR EXISTING DOCUMENTS -->
<div *ngIf="!isMissing" 
     style="background: white; border-radius: 12px; box-shadow: -1px 5px 15.6px rgba(119, 119, 119, 0.25); width: 212px; height: 200px; padding: 13px 16px; display: flex; flex-direction: column; position: relative;">
    
    <!-- Logo -->
    <div style="margin-bottom: 6px;">
        <img *ngIf="doc.instituteImage" [src]="doc.instituteImage" style="width: 50px; height: 50px; object-fit: cover; border-radius: 50%;" />
        <div *ngIf="!doc.instituteImage" style="width: 50px; height: 50px; background-color: #f8fafc; border: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: center; border-radius: 50%;">
            <i class="pi pi-building text-gray-500" style="font-size: 1.2rem;"></i>
        </div>
    </div>
    
    <!-- Action Button (Top Right) -->
    <button pButton pRipple class="p-button-rounded p-button-text absolute" 
            style="top: 10px; right: 10px; width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #6D6D6D;"
            [pTooltip]="doc.docType === DocumentTypeEnum.Drive ? 'Open Link' : 'Download Document'" tooltipPosition="top"
            (click)="openOrDownload()">
            <i class="pi" [ngClass]="doc.docType === DocumentTypeEnum.Drive ? 'pi-external-link' : 'pi-download'" style="font-size: 15px;"></i>
    </button>
    
    <!-- Title -->
    <h3 style="color: #2F2F9B; font-size: 16px; font-weight: 900; line-height: 20px; margin: 0; margin-bottom: 12px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-wrap: break-word;" [title]="doc.title">
        {{ doc.title }}
    </h3>
    
    <!-- Info Dots & Status -->
    <div style="display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; flex-grow: 1;">
        <div style="display: flex; align-items: center; gap: 6px;">
            <div style="width: 7px; height: 7px; background: #CED029; border-radius: 9999px;"></div>
            <div style="color: #6D6D6D; font-size: 10px; font-weight: 400; word-wrap: break-word;">
                {{ doc.docType === DocumentTypeEnum.Drive ? 'Google Doc' : 'Direct Upload' }}
            </div>
        </div>



        <!-- Requested By Info (for fulfilled requests) -->
        <div *ngIf="doc.isRequested" style="color: #64748B; font-size: 9px; font-weight: 500; margin-top: 2px;">
            Requested by: <span style="color: #1A1A2E; font-weight: 600;">{{ doc.requestedByUsername || 'Staff' }}</span>
        </div>


    </div>
    
    <!-- Footer Group -->
    <div style="display: flex; justify-content: space-between; align-items: flex-end;">
        
        <div style="display: flex; flex-direction: column; gap: 5px;">
            <!-- Date -->
            <div style="color: #6D6D6D; font-size: 13px; font-weight: 400; word-wrap: break-word;">
                {{ doc.createdAt | date:'MMM d, yyyy' }}
            </div>
        </div>
        
        <!-- Action Buttons -->
        <div *ngIf="!doc.isReadOnly && showActions" style="display: flex; gap: 6px;">
            <button pButton pRipple class="p-button-rounded border-none relative overflow-hidden" 
                    style="width: 27px; height: 27px; background: #2E04AC; border-radius: 24px; padding: 0; display: flex; align-items: center; justify-content: center; cursor: pointer;"
                    pTooltip="Replace Document" tooltipPosition="top"
                    (click)="editDocument()">
                    <div class="absolute w-full h-full z-2 bg-transparent" style="top: 0; left: 0;">
                        <img src="assets/icons/ReplaceDocument.svg" class="w-full h-full" style="object-fit: none;" onerror="this.style.display='none'" />
                    </div>
            </button>
            
            <button pButton pRipple class="p-button-rounded border-none" 
                    style="width: 27px; height: 27px; background: #FFCACA; border-radius: 24px; padding: 0; display: flex; align-items: center; justify-content: center; cursor: pointer;"
                    pTooltip="Delete Document" tooltipPosition="top"
                    (click)="deleteDocument()">
                    <i class="pi pi-trash" style="font-size: 14px; color: #ED0F0F;"></i>
            </button>
        </div>
    </div>
    
</div>
